import { z } from "zod";

export const billingCustomerAssociationSchema = z.object({
	customerId: z.number(),
	customerName: z.string(),
	ftCustomerId: z.number(),
});

export type BillingCustomerAssociation = z.infer<
	typeof billingCustomerAssociationSchema
>;
